import { indentFCMActions } from '@/constants/order';
import tmsMdmAxiosInstance from '@/tms-mdm-axios';
import HandleResponses from '@common/utils/handleResponses';
import axios from '../../../axios';
import tmsIndentAxiosInstance from '../../../tms-indent-axios';
import tmsOptimaAxiosInstance from '../../../tms-optima-axios';

const Cache = {
  getOrder(orders, orderId) {
    if (!orders.length) {
      return false;
    }
    const orderShowKey = 'base_frieght';
    let order = orders.find(orderData => (orderData.order_number === orderId ||
      (orderData.returnIndents && orderData.returnIndents[0] &&
        orderData.returnIndents[0].order_number === orderId)));
    if (order && order.returnIndents && order.returnIndents[0] &&
      order.returnIndents[0].order_number === orderId) {
      order = order.returnIndents[0];
    }
    if (order && order[orderShowKey]) {
      return order;
    }
    return false;
  },

  index(id, items, keyToMatch = 'order_number') {
    const len = items.length;
    for (let i = 0; i < len; i += 1) {
      if (id === items[i][keyToMatch]) {
        return i;
      }
    }
    return -1;
  },

  setOrder(orders, data) {
    const ordersList = [...orders];
    let orderData = data;
    const orderId = data.order_number;
    let index = -1;
    if (data.parentIndentId) { // it is a child indent
      index = this.index(data.parentIndentId, orders, 'id');
      if (index !== -1 && ordersList[index]) { // hasReturnIndents
        orderData = {
          ...ordersList[index],
          returnIndents: data, // add it to return indent
        };
      }
    } else {
      index = this.index(orderId, ordersList);
      if (ordersList[index]) { // hasReturnIndents
        orderData = {
          ...orderData,
          returnIndents: ordersList[index].returnIndents, // add it to return indent
        };
      }
    }
    ordersList.splice(index, 1, orderData);
    return ordersList;
  },
};


const actions = {
  async setTruckWeight({ commit, state }, params) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${params.orderNo}/truck_weight`, { data: params.data });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
      }
      return result.data;
    } catch (error) {
      return error;
    }
  },

  async create({ commit }, params) {
    commit('SET_ORDER_PROCESSING', true);
    try {
      const result = await tmsIndentAxiosInstance.post('/order/', { data: params.data });
      commit('SET_LATEST_ORDER', result.data.order_number);
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('SET_ORDER_PROCESSING', false);
    }
  },

  async update({ commit }, params) {
    commit('SET_ORDER_PROCESSING', true);
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${params.id}`, { data: params.data });
      if (result && result.data) {
        commit('SET_LATEST_ORDER', result.data.order_number);
      }
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('SET_ORDER_PROCESSING', false);
    }
  },

  async reindent({ commit, state }, params) {
    commit('SET_ORDER_PROCESSING', true);
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${params.id}/reindent`, { data: params.data });

      if (result.data && result.data.id) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
      }
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('SET_ORDER_PROCESSING', false);
    }
  },
  async reIndentForFirstInAllotment({ commit, state }, params) {
    commit('SET_ORDER_PROCESSING', true);
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${params.id}/first_in_allotment/reindent`, { data: params.data });

      if (result.data && result.data.id) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
      }
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('SET_ORDER_PROCESSING', false);
    }
  },

  async loadPlan({ commit }, orderId) {
    try {
      commit('SET_ORDER_LOADING', true);
      const result = await tmsIndentAxiosInstance({
        url: `/order/${orderId}/load_planner`,
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `loadPlanner -${now}.xlsx`); // or any other extension
        document.body.appendChild(link);

        link.click();
      }
      return result;
    } catch (error) {
      return error;
    } finally {
      commit('SET_ORDER_LOADING', false);
    }
  },

  async all({ commit }) {
    commit('SET_ALL_ORDERS_LOADING', true);
    const result = await tmsIndentAxiosInstance('/order');
    commit('SET_ALL_ORDERS', result.data);
    commit('SET_FILTER', null);
    commit('SET_ALL_ORDERS_LOADING', false);
  },

  async find({ commit, state }, payload) {
    let orderId;
    let isEdit = false;

    if (payload && typeof payload === 'object') {
      ({ orderId, isEdit = false } = payload);
    } else {
      orderId = payload;
    }
    const orders = state.all;
    try {
      commit('SET_ORDER_LOADING', true);
      const result = await tmsIndentAxiosInstance(`/order/${orderId}?isEdit=${isEdit}`);
      commit('UPDATE_ORDER', result.data);
      if (result.data) {
        const updatedOrders = Cache.setOrder(orders, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
      }
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('SET_ORDER_LOADING', false);
    }
  },

  async getRfq({ commit, state }, orderId) {
    try {
      const result = await tmsIndentAxiosInstance(`/order/${orderId}/rfq_details`);
      commit('UPDATE_ORDER', result.data);
      if (result.data) {
        const updatedOrders = Cache.setOrder(orders, state.order);
        commit('SET_ALL_ORDERS', updatedOrders);
      }
    } catch (error) {
      return error;
    }
  },

  async getCancelRemarks({ commit, state }, orderId) {
    try {
      const result = await tmsIndentAxiosInstance(`/order/${orderId}/cancel_details`);
      commit('UPDATE_ORDER', result.data);
      if (result.data) {
        const updatedOrders = Cache.setOrder(orders, state.order);
        commit('SET_ALL_ORDERS', updatedOrders);
      }
    } catch (error) {
      return error;
    }
  },

  async getOrderHistory({ commit, state }, orderId) {
    try {
      const result = await tmsIndentAxiosInstance(`/order/${orderId}/order_history`);
      commit('UPDATE_ORDER', result.data);
      if (result.data) {
        const updatedOrders = Cache.setOrder(orders, state.order);
        commit('SET_ALL_ORDERS', updatedOrders);
      }
    } catch (error) {
      return error;
    }
  },

  async reconciliation({ commit }, orderId) {
    try {
      commit('SET_RECONCILIATION_LOADING', true);
      const result = await tmsIndentAxiosInstance(`/order/${orderId}/reconciliation`);
      if (result) {
        commit('SET_RECONCILIATION', result);
      }
      return result;
    } catch (error) {
      commit('SET_RECONCILIATION_LOADING', false);
      return error;
    } finally {
      commit('SET_RECONCILIATION_LOADING', false);
    }
  },
  async updaterReconciliation({ commit }, { orderId, payload }) {
    try {
      commit('SET_RECONCILIATION_LOADING', true);
      const result = await tmsIndentAxiosInstance.post(`/order/${orderId}/reconciliation`, { data: payload });
      return result;
    } catch (error) {
      commit('SET_RECONCILIATION_LOADING', false);
      return error;
    } finally {
      commit('SET_RECONCILIATION_LOADING', false);
    }
  },
  // NOTE:- change this. - sekar
  async vehicleFind({ commit, state }, orderId) { // eslint-disable-line
    try {
      const orders = state.all;
      commit('SET_ORDER_LOADING', true);
      const result = await tmsIndentAxiosInstance(`/order/${orderId}`);
      commit('SET_ORDER', result.data);
      if (result.data) {
        const updatedOrders = Cache.setOrder(orders, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
      }
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('SET_ORDER_LOADING', false);
    }
  },
  /* Pay anomaly APIs start */
  async getPayAnomalyData({ commit }, { orderId }) {
    try {
      commit('SET_PAY_ANOMALY_LOADING', true);
      const result = await axios.get(`/v2/shipper/payment-anomaly/${orderId}`);
      const data = result && result.data;
      if (data) {
        commit('SET_PAY_ANOMALY', data);
      }
      return data;
    } catch (error) {
      commit('SET_PAY_ANOMALY_LOADING', false);
      return error;
    } finally {
      commit('SET_PAY_ANOMALY_LOADING', false);
    }
  },
  async approvePayment(_, { orderId, clientId }) {
    try {
      const result = await axios.post('/v2/retriggerPayment',
        { orderId, clientId },
      );
      return result;
    } catch (error) {
      return error;
    }
  },
  /* Pay anomaly APIs end */
  async filter({ commit }, { params }) {
    try {
      commit('SET_ALL_ORDERS_LOADING', true);
      if (parseInt(params.page, 10) === 1) {
        commit('SET_ALL_ORDERS', []);
      }
      const result = await tmsIndentAxiosInstance('/order/filter', { params });
      commit('SET_FILTER', params);
      commit('SET_DEPOT', params.depot_id);
      commit('SET_ALL_ORDERS', result.data);
      commit('SET_COUNT', result.meta);
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('SET_ALL_ORDERS_LOADING', false);
    }
  },

  async paginate({ commit }, { params }) {
    try {
      commit('SET_PAGINATION_STATUS', true);
      const result = await tmsIndentAxiosInstance('/order/filter', { params });
      commit('SET_PAGINATED_DATA', result.data);
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('SET_PAGINATION_STATUS', false);
    }
  },

  async resetFilter({ commit, state }) {
    const filterParam = {
      order_number: null,
      vehicle_number: null,
      lr_number: null,
      transporter: null,
      destination: null,
      consignee: null,
      date: null,
      start: null,
      end: null,
      status: null,
      page: 1,
      depot_id: state.filter.depot_id,
      category: state.filter.category,
    };
    commit('SET_FILTER', filterParam);
  },

  async updateFilter({ commit, state }, { type, value }) {
    const filterParam = state.filter;
    filterParam[type] = value;
    commit('SET_FILTER', filterParam);
  },

  async getDeliveryNumbers({ commit }, { orderNo }) {
    try {
      const result = await tmsIndentAxiosInstance.get(`/order/${orderNo}/delivery_numbers`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getLRDetails({ commit }, { orderId }) {
    try {
      const result = await tmsIndentAxiosInstance.get(`/order/${orderId}/lr_details`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async assignTruck({ commit, state, dispatch }, params) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${params.id}/assign_truck`, { data: params.data });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async driverValidation(_, data) {
    try {
      const result = await tmsIndentAxiosInstance.post('/order/assign_truck/validate', data);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async getVerification(_, data) {
    try {
      const result = await tmsIndentAxiosInstance.get(`/order/${data.orderNo}/assign_truck/validate_status?transaction_id=${data.transactionId}`);
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  syncEximModule({ dispatch, commit }, data) {
    if (data && data.master_indent) {
      dispatch('exim/fetchChildIndent', { indentNo: data.master_indent }, { root: true });
      commit('exim/updateMasterIndentById', { masterIndentNo: data.master_indent, status: data.master_indent_status }, { root: true });
    }
  },
  async changeTruck({ commit, state, dispatch }, params) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${params.id}/truck`, { data: params.data }, {
        params: {
          ...params.ptlGroupId ? { ptl_group_id: params.ptlGroupId } : {},
        },
      });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async activeTrip({ commit, state, dispatch }, params) {
    try {
      const result = await axios.get('/track-trip', { params });
      return result && result.data && result.data[0];
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async isPtlGrouping({ commit }, { orderNo }) {
    try {
      const result = await tmsIndentAxiosInstance.get(`/order/${orderNo}/ptl_grouping`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async isDuplicateVehicleAssignment({ commit }, { vehicleNumber, orderNo }) {
    try {
      const result = await tmsMdmAxiosInstance.get(`/vehicle/${vehicleNumber}/indents?orderNo=${orderNo}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async isDetailsExist({ commit, state, dispatch }, { orderNo, vehicleNumber }) {
    try {
      const result = await tmsIndentAxiosInstance.get(`/order/${orderNo}/is_vehicle_or_driver_number_exists?vehicle_number=${vehicleNumber}`);
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async denyTruckChangeRequest({ commit, state }, params) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${params}/deny_truckchange_request`, {});
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
      }
      return result.data;
    } catch (error) {
      return error;
    }
  },

  async truckIn({ commit, state, dispatch }, params) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${params.id}/truck_in`, { data: params.data }, {
        params: {
          ...params.ptlGroupId ? { ptl_group_id: params.ptlGroupId } : {},
        },
      });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result;
    } catch (error) {
      // log
      return HandleResponses.Status(error);
    }
  },

  async enableGatePass({ commit, state, dispatch }, params) {
    try {
      const result = await tmsIndentAxiosInstance.post(`/order/${params.id}/enable_gate_pass`);
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result.data;
    } catch (error) {
      return error;
    }
  },


  async containerPicked({ commit, state, dispatch }, params) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${params.id}/container_picked`, { data: params.data });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async startLoading({ commit, state, dispatch }, { id, data, ptlGroupId }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${id}/start_load`, { data }, {
        params: {
          ...ptlGroupId ? { ptl_group_id: ptlGroupId } : {},
        },
      });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async endLoading({ commit, state, dispatch }, { id, data, ptlGroupId }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${id}/end_load`, { data }, {
        params: {
          ...ptlGroupId ? { ptl_group_id: ptlGroupId } : {},
        },
      });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getUpdatedOrder({ commit }, { orderId }) {
    try {
      commit('SET_ORDER_LOADING', true);
      const result = await tmsIndentAxiosInstance(`/order/${orderId}`);
      commit('SET_ORDER', result.data);
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('SET_ORDER_LOADING', false);
    }
  },

  async cancel({ commit, state, dispatch }, { id, comment }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${id}/cancel`, { data: { comment } });
      commit('SET_ORDER', result.data);
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async deleteDraft({ commit }, id) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${id}/delete_draft`);
      if (result && result.data) {
        commit('REMOVE_FROM_ALL_ORDERS', id);
      }
      return result && result.data;
    } catch (error) {
      return error;
    }
  },

  async truckout({ commit, state, dispatch }, { id, data, ptlGroupId }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${id}/truck_out`, { data }, {
        params: {
          ...ptlGroupId ? { ptl_group_id: ptlGroupId } : {},
        },
      });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async updateSealNumberDetails(_, { orderNo, data }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/seal_number_update`, { data });
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async emptyContainerReturned({ commit, state, dispatch }, { id, data }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${id}/empty_container_return`, { data });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async ewayBill({ commit, state, dispatch }, { id, data }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${id}/eway_bill`, { data });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async search({ commit }, params) {
    try {
      const result = await tmsIndentAxiosInstance('/order/search', { params });
      if (result.data) {
        commit('SET_ALL_ORDERS', result.data);
      }
      return result.data;
    } catch (error) {
      return error;
    }
  },

  async count({ commit }, { params }) {
    try {
      const result = await tmsIndentAxiosInstance('/order/count', { params });
      if (result.meta) {
        commit('SET_COUNT', result.meta);
      }
      return result.meta;
    } catch (error) {
      return error;
    }
  },

  async materials({ commit }, { orderId, consigneeId, params }) {
    try {
      commit('SET_MATERIAL_LOADING', true);
      const result = await tmsIndentAxiosInstance(`/order/${orderId}/materials`, { params });
      if (result.data) {
        commit('SET_MATERIALS', result.data);
      }
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('SET_MATERIAL_LOADING', false);
    }
  },

  async uploadMaterials({ }, { orderId, attachment }) { // eslint-disable-line
    try {
      const config = { headers: { 'Content-Type': 'multipart/form-data' } };
      const formData = new FormData();
      formData.append('attachment', attachment);
      const result = await tmsIndentAxiosInstance.put(`/order/${orderId}/materials`, formData, config);
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async bulkPodUpload({ }, { file }) {
    try {
      const config = { headers: { 'Content-Type': 'multipart/form-data' } };
      const formData = new FormData();
      formData.append('attachment', file);
      const result = await tmsIndentAxiosInstance.put('/order/deliver', formData, config);
      return result;
    } catch (error) {
      return error;
    }
  },

  async uploadOrderMaterials({ commit }, { invoice, isMaterialWithPackageConfigEnabled }) { // eslint-disable-line
    try {
      commit('ORDER_BULK_PROCESSING', true);
      const config = { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 60000 * 5 };
      const formData = new FormData();
      formData.append('attachment', invoice);
      let result = {};
      if (isMaterialWithPackageConfigEnabled) {
        result = await tmsIndentAxiosInstance.put('/order/material_with_package', formData, config);
      } else {
        result = await tmsIndentAxiosInstance.put('/order/material', formData, config);
      }
      return result;
    } catch (error) {
      commit('ORDER_BULK_PROCESSING', false);
      return error;
    }
  },

  async uploadOrderMaterialsDelete({ commit }, materials) { // eslint-disable-line
    try {
      commit('ORDER_BULK_PROCESSING', true);
      const config = { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 60000 * 5 };
      const formData = new FormData();
      formData.append('attachment', materials);
      const result = await tmsIndentAxiosInstance.put('/order/material_delete', formData, config);
      return result;
    } catch (error) {
      commit('ORDER_BULK_PROCESSING', false);
      return error;
    }
  },

  async materialInvoiceGrnBulkUpload({ commit }, { attachment }) { // eslint-disable-line
    try {
      commit('ORDER_BULK_PROCESSING', true);
      const config = { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 60000 * 5 };
      const formData = new FormData();
      formData.append('attachment', attachment);
      const result = await tmsIndentAxiosInstance.put('/order/material_invoice_grn', formData, config);
      return result;
    } catch (error) {
      commit('ORDER_BULK_PROCESSING', false);
      return error;
    }
  },


  async deleteMaterials({ }, params) { // eslint-disable-line
    try {
      const result = await tmsIndentAxiosInstance.delete(`/order/${params.orderId}/materials`, {
        data: { data: params.materials },
      });
      return result;
    } catch (error) {
      return error;
    }
  },
  async deleteMaterialInvoiceLR({ }, params) {
    try {
      const result = await tmsIndentAxiosInstance.delete(`/order/${params.orderId}/material_invoice_lr`, {
        data: { data: params.materialDetails },
      });
      return result;
    } catch (error) {
      return error;
    }
  },
  async deleteGateMaterials({ }, params) { // eslint-disable-line
    try {
      const result = await tmsIndentAxiosInstance.delete(`/order/${params.orderNo}/gate_materials`, {
        data: { data: { gate_id: params.gateId } },
      });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async addDocks({ commit, state }, { orderId, data }) { // eslint-disable-line
    try {
      let result = null;
      if (!state.isOrderProcessing) {
        commit('SET_ORDER_PROCESSING', true);
        result = await tmsIndentAxiosInstance.put(`/order/${orderId}/docks`, { data });
        if (result.data) {
          const updatedOrders = Cache.setOrder(state.all, result.data);
          commit('SET_ALL_ORDERS', updatedOrders);
        }
      }
      return result && result.data;
    } catch (error) {
      return error;
    } finally {
      commit('SET_ORDER_PROCESSING', false);
    }
  },

  async startLoadingAtGate({ commit, state, dispatch }, { id, data, ptlGroupId }) { // eslint-disable-line
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${id}/start_load`, { data }, {
        params: {
          ...ptlGroupId ? { ptl_group_id: ptlGroupId } : {},
        },
      });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async endLoadingAtGate({ commit, state, dispatch }, { id, data, ptlGroupId }) { // eslint-disable-line
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${id}/end_load`, { data }, {
        params: {
          ...ptlGroupId ? { ptl_group_id: ptlGroupId } : {},
        },
      });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async reachedFirstLoadingPoint({ commit, state, dispatch }, { id, unique_id, ptlGroupId }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${id}/load_point`, { data: { unique_id } }, {
        params: {
          ...ptlGroupId ? { ptl_group_id: ptlGroupId } : {},
        },
      });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result;
    } catch (error) {
      return error;
    }
  },

  async inspection({ commit, state, dispatch }, { id, data, ptlGroupId }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${id}/inspection`, { data }, {
        params: {
          ...ptlGroupId ? { ptl_group_id: ptlGroupId } : {},
        },
      });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async inspectionAtDestination({ commit, state, dispatch }, { id, data, ptlGroupId }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${id}/inspection_at_destination`, { data }, {
        params: {
          ...ptlGroupId ? { ptl_group_id: ptlGroupId } : {},
        },
      });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async lorryReceipt({ commit }, orderId) { // eslint-disable-line
    try {
      commit('SET_LR_LOADING', true);
      const result = await tmsIndentAxiosInstance.get(`/order/${orderId}/lorry_receipt`);
      if (result.data) {
        commit('SET_LR', result.data);
      }
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('SET_LR_LOADING', false);
    }
  },


  async saveLorryReceipt({ commit }, { orderId, data }) { // eslint-disable-line
    try {
      await tmsIndentAxiosInstance.put(`/order/${orderId}/lorry_receipt`, { data });
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async saveConsignmentNumber({ commit }, { orderId, consigneeId, data }) { // eslint-disable-line
    try {
      await tmsIndentAxiosInstance.put(`/order/${orderId}/consignee/${consigneeId}/consignment_number`, { data });
      return true;
    } catch (error) {
      const errorData = error.data && error.data.errors;
      if (errorData && errorData.length) {
        const errorMessage = error.data.errors[0] ? error.data.errors[0].message : '';
        return { error: errorMessage };
      }
      return HandleResponses.Status(error);
    }
  },
  async saveWeighBridgeDetails({ commit }, { orderId, data }) { // eslint-disable-line
    try {
      await tmsIndentAxiosInstance.put(`/order/${orderId}/weigh_bridge`, { data });
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },


  async getLrAttachments(_, { orderId }) {
    let result;
    try {
      result = await tmsIndentAxiosInstance.get(`/order/${orderId}/lr`);
    } catch (error) {
      result = HandleResponses.Status(error);
    }
    return result;
  },

  async saveLr({ }, { orderNo, data }) { // eslint-disable-line
    try {
      return tmsIndentAxiosInstance.put(`/order/${orderNo}/lr`, { data });
    } catch (error) {
      return error;
    }
  },


  async attachments({ commit }, { ids, skipClientId }) { // eslint-disable-line
    try {
      const result = await axios('/attachment', { params: { ids, skipClientId } });
      return result.data;
    } catch (error) {
      return error;
    }
  },

  async addAttachment(_, data) {
    try {
      const result = await axios.post('/attachment', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getLegalEntity(_, { orderNo }) {
    try {
      const result = await tmsIndentAxiosInstance.get(`/order/${orderNo}/legal_entity`);
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async approveSDCSubmission(_, { orderNo }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/epod/approve`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async rejectSDCSubmission(_, { orderNo, reason }) {
    try {
      const result = await tmsIndentAxiosInstance.put(
        `/order/${orderNo}/epod/reject`,
        { data: { reason } },
      );
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async removeAttachment(_, { data }) {
    try {
      const result = await tmsIndentAxiosInstance.delete(`order/${data.indent_id}/consignee/${data.consignee_id}/lr/${data.file_id}`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async rejectLRAttachment(_, { orderId, attchmentId, data }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`order/${orderId}/lr_attachment_reject/${attchmentId}`, { data });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async track({ commit, state }, { id }) { // eslint-disable-line
    try {
      const result = await tmsIndentAxiosInstance.put(`order/${id}/track`);
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        commit('SET_ORDER', result.data);
      }
      return result.data;
    } catch (error) {
      return error;
    }
  },

  async sendconsent(_, { phone }) { // eslint-disable-line
    try {
      const result = await tmsIndentAxiosInstance.put(`order/${phone}/sendconsent`);
      return result.data;
    } catch (error) {
      return error;
    }
  },

  async hyperTrack({ commit, state }, orderId) { // eslint-disable-line
    try {
      const result = await tmsIndentAxiosInstance.get(`order/${orderId}/track`);
      if (result.data) {
        commit('SET_HYPERTRACK', result.data);
      }
      return result.data;
    } catch (error) {
      return error;
    }
  },

  async deliver({ commit, state, dispatch }, { id, data }) { // eslint-disable-line
    try {
      const result = await tmsIndentAxiosInstance.put(`order/${id}/deliver`, { data });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async deliverStatus(_, { order_number }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`order/${order_number}/deliver/status`);
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async customFields({ commit, state }, { orderId, data }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderId}/custom_field`, { data });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
      }
      return result.data;
    } catch (err) {
      return false;
    }
  },

  async location({ commit }, { orderNo }) {
    try {
      const result = await tmsIndentAxiosInstance(`order/${orderNo}/track_location`);
      if (result) {
        commit('SET_LOCATION_DATA', result);
        return result;
      }
      return false;
    } catch (err) {
      return false;
    }
  },
  async appLocation({ commit }, orderNo) {
    try {
      const result = await tmsIndentAxiosInstance(`order/${orderNo}/locations`);
      if (result.data) {
        commit('SET_LOCATION_DATA', result.data);
        return result.data;
      }
      return false;
    } catch (err) {
      return false;
    }
  },

  async getconsent(_, { phone }) {
    try {
      const result = await axios(`simtrack/getconsents?phone=${phone}`);
      if (result.data) {
        return result.data;
      }
      return false;
    } catch (err) {
      return false;
    }
  },

  async bulkUpload({ commit }, { formData }) {
    commit('ORDER_BULK_PROCESSING', true);
    try {
      const result = await tmsIndentAxiosInstance.post('/order/bulkupload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return result;
    } catch (error) {
      commit('ORDER_BULK_PROCESSING', false);
      return error;
    }
  },

  async lrBulkUpload({ commit }, { formData }) {
    commit('LR_BULK_PROCESSING', true);
    try {
      const result = await tmsIndentAxiosInstance.post('/order/lr_bulk_upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return result;
    } catch (error) {
      commit('LR_BULK_PROCESSING', false);
      return error;
    }
  },

  async directDeliveryBulkUpload({ commit }, { formData }) {
    commit('ORDER_BULK_PROCESSING', true);
    try {
      const result = await tmsIndentAxiosInstance.post('/order/direct_delivery_bulk_upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return result;
    } catch (error) {
      commit('ORDER_BULK_PROCESSING', false);
      return error;
    }
  },

  async directDispatchBulkUpload({ commit }, { formData }) {
    commit('ORDER_BULK_PROCESSING', true);
    try {
      const result = await tmsIndentAxiosInstance.post('/order/direct_dispatch_bulk_upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return result;
    } catch (error) {
      commit('ORDER_BULK_PROCESSING', false);
      return error;
    }
  },

  async chargeableWeightBulkUpload({ commit }, { formData }) {
    commit('ORDER_BULK_PROCESSING', true);
    try {
      const result = await tmsIndentAxiosInstance.post('/order/chargeable_weight_bulk_upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return result;
    } catch (error) {
      commit('ORDER_BULK_PROCESSING', false);
      return error;
    }
  },
  async chargeableWeightUploadStatus({ commit }) {
    try {
      const result = await tmsIndentAxiosInstance.get('/order/chargeable_weight_bulk_upload_status');
      if (result.data && result.data.code === 'COMPLETED') {
        commit('ORDER_BULK_PROCESSING', false);
      }
      return result.data;
    } catch (error) {
      commit('ORDER_BULK_PROCESSING', false);
      return error;
    }
  },
  async chargeableWeightRejectDownload(_, { data }) {
    try {
      const result = await tmsIndentAxiosInstance({
        url: `/order/download_chargeable_weight_rejected?transaction_id=${data.transactionId.join(',')}`,
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `chargeable-weight-rejectedList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      }
      return result;
    } catch (err) {
      return err;
    }
  },

  async uploadDirectDeliveryStatus({ commit }) {
    try {
      const result = await tmsIndentAxiosInstance('/order/direct_delivery_upload_status');
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('ORDER_BULK_PROCESSING', false);
    }
  },

  async uploadDirectDispatchStatus({ commit }) {
    try {
      const result = await tmsIndentAxiosInstance('/order/direct_dispatch_upload_status');
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('ORDER_BULK_PROCESSING', false);
    }
  },

  async uploadStatus({ commit }) {
    try {
      const result = await tmsIndentAxiosInstance('/order/upload_status');
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('ORDER_BULK_PROCESSING', false);
    }
  },

  async lrUploadStatus({ commit }) {
    try {
      const result = await tmsIndentAxiosInstance('/order/lr_upload_status');
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('ORDER_BULK_PROCESSING', false);
    }
  },

  async orderMaterialUploadStatus({ commit }, { isMaterialWithPackageConfigEnabled }) {
    try {
      let result = {};
      if (isMaterialWithPackageConfigEnabled) {
        result = await tmsIndentAxiosInstance('/order/material_package_upload_status');
      } else {
        result = await tmsIndentAxiosInstance('/order/material_upload_status');
      }
      if (result.data.code !== 'PROGRESS') {
        commit('ORDER_BULK_PROCESSING', false);
      }
      return result;
    } catch (error) {
      return error;
    }
  },
  async materialDeleteStatus({ commit }) {
    try {
      const result = await tmsIndentAxiosInstance('/order/material_delete_status');
      return result;
    } catch (error) {
      return error;
    } finally {
      commit('ORDER_BULK_PROCESSING', false);
    }
  },
  async materialInvoiceGrnUploadStatus({ commit }) {
    try {
      const result = await tmsIndentAxiosInstance('/order/material_invoice_grn_upload_status');
      return result;
    } catch (error) {
      return error;
    } finally {
      commit('ORDER_BULK_PROCESSING', false);
    }
  },

  async rejectDownload({ commit }) {
    commit('ORDER_BULK_PROCESSING', false);
    try {
      const result = await tmsIndentAxiosInstance({
        url: 'order/rejected_orders',
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `indent-rejectedList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);

        link.click();
      }
      return true;
    } catch (err) {
      return err;
    } finally {
      commit('ORDER_BULK_PROCESSING', false);
    }
  },

  async rejectDownloadGRN({ commit }, { transactionId }) {
    commit('ORDER_BULK_PROCESSING', false);
    try {
      const result = await tmsIndentAxiosInstance({
        url: `order/rejected_grn/${transactionId}`,
        method: 'PUT',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `grn-rejectedList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);

        link.click();
      }
      return true;
    } catch (err) {
      return err;
    } finally {
      commit('ORDER_BULK_PROCESSING', false);
    }
  },

  async rejectDownloadMaterial({ commit }, { data, isMaterialWithPackageConfigEnabled }) {
    commit('ORDER_BULK_PROCESSING', false);
    const url = isMaterialWithPackageConfigEnabled ? 'order/rejected_materials_with_packages' :
      'order/rejected_materials';

    try {
      const result = await tmsIndentAxiosInstance({
        url,
        data: { data },
        method: 'POST',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `material-rejectedList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);

        link.click();
      }
      return true;
    } catch (err) {
      return err;
    } finally {
      commit('ORDER_BULK_PROCESSING', false);
    }
  },
  async materialDeleteRejectDownload({ commit }, { data }) {
    commit('ORDER_BULK_PROCESSING', false);
    try {
      const result = await tmsIndentAxiosInstance({
        url: `order/download_material_delete_rejected?transaction_id=${data.invalid_transaction_ids.join(',')}`,
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `material-delete-rejectedList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);

        link.click();
      }
      return true;
    } catch (err) {
      return err;
    } finally {
      commit('ORDER_BULK_PROCESSING', false);
    }
  },

  async lrRejectionDownload({ commit }, { data }) {
    commit('ORDER_BULK_PROCESSING', false);
    try {
      const result = await tmsIndentAxiosInstance({
        url: `order/lr_rejection/download?transaction_id=${data.transactionId.join(',')}`,
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `lr-rejectedList-${now}.xlsx`);
        document.body.appendChild(link);

        link.click();
      }
      return true;
    } catch (err) {
      return err;
    } finally {
      commit('ORDER_BULK_PROCESSING', false);
    }
  },

  async materialInvoiceGrnRejectDownload({ commit }, { data }) {
    commit('ORDER_BULK_PROCESSING', false);
    try {
      const result = await tmsIndentAxiosInstance({
        url: `order/rejected_materials_invoice_grn?transactionId=${data.invalid_transaction_ids.join(',')}`,
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `material-invoice-grn-rejectedList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);

        link.click();
      }
      return true;
    } catch (err) {
      return err;
    } finally {
      commit('ORDER_BULK_PROCESSING', false);
    }
  },

  async materialDeleteRejectSendMail({ commit }, { data }) {
    commit('ORDER_BULK_PROCESSING', false);
    try {
      const result = await tmsIndentAxiosInstance({
        url: `order/download_material_delete_rejected?transaction_id=${data.invalid_transaction_ids.join(',')}`,
        method: 'GET',
      });
      return result;
    } catch (err) {
      return err;
    } finally {
      commit('ORDER_BULK_PROCESSING', false);
    }
  },

  async directDeliveryRejectDownload({ commit }) {
    commit('ORDER_BULK_PROCESSING', false);
    try {
      const result = await tmsIndentAxiosInstance({
        url: 'order/rejected_direct_delivery',
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `direct-delivery-rejectedList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (err) {
      return err;
    } finally {
      commit('ORDER_BULK_PROCESSING', false);
    }
  },

  async podBulkUpload({ commit }, { formData }) {
    commit('ORDER_BULK_PROCESSING', true);
    try {
      const result = await tmsIndentAxiosInstance.post('/order/pod_bulkupload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return HandleResponses.Status(result);
    } catch (error) {
      commit('ORDER_BULK_PROCESSING', false);
      return HandleResponses.Status(error);
    }
  },

  async podUploadStatus({ commit }) {
    try {
      const result = await tmsIndentAxiosInstance('/order/pod_upload_status');
      if (result.data.code !== 'PROGRESS') {
        commit('ORDER_BULK_PROCESSING', false);
      }
      return result.data;
    } catch (error) {
      commit('ORDER_BULK_PROCESSING', false);
      return HandleResponses.Status(error);
    }
  },
  async freightRateUpdate({ commit, state, dispatch }, { orderNo, data }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/freight_charge`,
        { data });
      if (result.data && result.data.id) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async vehicleTypeUpdate({ commit, state, dispatch }, { orderNo, data }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/vehicle_type`,
        { data });
      if (result.data && result.data.id) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
      }
      return result.data;
    } catch (error) {
      if (error.data) {
        return error.data;
      }
      return HandleResponses.Status(error);
    }
  },
  // will use it later
  // async invoiceDetails({ commit }, orderNo) {
  //   try {
  //     const result = await axios.get(`/v2/shipper/invoice/details/${orderNo}`);
  //     if (result.indent_id) {
  //       commit('SET_INVOICE_DETAILS', result);
  //     }
  //     return result;
  //   } catch (err) {
  //     throw err;
  //   }
  // },
  async materialHeaders({ commit }) {
    try {
      const result = await tmsIndentAxiosInstance.get('/order/material_header');
      if (result.data) {
        commit('SET_MATERIAL_HEADER', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  // async grn({ commit }, { orderId }) {
  //   try {
  //     commit('SET_GRN_LOADING', true);
  //     const result = await tmsIndentAxiosInstance.get(`/order/${orderId}/grn`);
  //     if (result.data) {
  //       commit('SET_GRN', result.data);
  //     }
  //     return result.data;
  //   } catch (error) {
  //     return HandleResponses.Status(error);
  //   } finally {
  //     commit('SET_GRN_LOADING', false);
  //   }
  // },

  async gettransporter({ commit }, { orderId, vehicleTypeId }) {
    try {
      let queryParams = '';
      if (vehicleTypeId) {
        queryParams += `?vehicleTypeId=${vehicleTypeId}`;
      }
      const result = await tmsIndentAxiosInstance
        .get(`/order/${orderId}/transporter${queryParams}`);
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async rfq({ commit, state }, params) {
    try {
      const { orderNo, loadDate, transporterIds, freight_unit, ceiling_price,
        historical_price, no_of_materials, material_weight, material_volume,
        is_all_selected, changed_vehicle_id, remarks, reindent_reason } = params;
      const data = {
        loading_date: loadDate,
        transporter_ids: transporterIds,
        freight_unit,
        ceiling_price,
        no_of_materials,
        material_weight,
        material_volume,
        is_all_selected,
        changed_vehicle_id,
        remarks,
        reindent_reason,
      };
      if (historical_price === 0 || historical_price) {
        data.historical_price = historical_price;
      }
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/rfq`, { data });
      if (result.data && result.data.id) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
      }
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getrfqtransporters({ commit }, { orderNo }) {
    try {
      const result = await tmsIndentAxiosInstance.get(`/order/${orderNo}/rfq`);
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async rfqupdate({ commit, state, dispatch }, { orderNo, payload }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/transporter_rfq`, {
        data: payload,
      });
      if (result.data && result.data.id) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      // commit('SET_GRN_LOADING', false);
    }
  },

  async truckReportedAt({ commit, state, dispatch }, { orderNo, ptlGroupId }) {
    try {
      const data = {
        reported_at: new Date(),
      };
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/report_at`, { data }, {
        params: {
          ...ptlGroupId ? { ptl_group_id: ptlGroupId } : {},
        },
      });
      if (result.data && result.data.id) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async approvePod({ commit }, { orderNo, data }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/epod_approve`, { data });
      commit('SET_MATERIALS', result.data);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async saveGrn({ commit }, { orderNo, mat, consigneeId, inbound, packages }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/consignee/${consigneeId}/epod`,
        { data: { mat, inbound, packages } });
      commit('SET_MATERIALS', result.data);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async rejectEpod({ commit }, { orderNo, consigneeId, consigneeLocationId, reason, dateTime, depotName,
    route, vehicleNumber, transporterName, transporterId }) {
    try {
      let result;
      if (consigneeId) {
        result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/consignee/${consigneeId}/epod_reject`,
          { data: { reason, consigneeId, dateTime, depotName, route, vehicleNumber, transporterName, transporterId } });
      } else if (consigneeLocationId) {
        result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/consignee/${consigneeLocationId}/epod_reject`,
          { data: { reason, consigneeLocationId, dateTime, depotName, route, vehicleNumber, transporterName, transporterId } });
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async markDelivered(_, { orderNo, consigneesIds }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/deliver`,
        { data: consigneesIds });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async saveReturnMaterials({ commit }, { orderNo, data, consigneeId }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/consignee/${consigneeId}/return_materials`,
        { data });
      commit('SET_MATERIALS', result.data);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async updateEdd({ commit, state, dispatch }, { id, data }) { // eslint-disable-line
    try {
      const result = await tmsIndentAxiosInstance.put(`order/${id}/expected_delivery_at`, { data });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result.data;
    } catch (error) {
      return error;
    }
  },

  async retriggerEpod(_, { orderNo }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/retrigger_epod`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async triggerZpod(_, { orderNo }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/trigger_zpod`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async truckChangeComment({ commit, dispatch }, orderNo) {
    try {
      const result = await tmsIndentAxiosInstance.get(`/order/${orderNo}/truck_change_comment`);
      commit('SET_TRUCK_CHANGE_COMMENTS', result.data);
      dispatch('syncEximModule', result.data);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async shareOfBusiness(_, params) {
    try {
      const { orderNo, contractId } = params;
      return tmsIndentAxiosInstance.get(`/order/${orderNo}/${contractId}/share_of_business`);
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async idealAndRunningSob(_, payload) {
    try {
      return await tmsIndentAxiosInstance.post('/order/ideal_running_sob', { data: payload });
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async downloadMaterial({ commit }, orderNo) {
    try {
      const result = await tmsIndentAxiosInstance({
        url: `order/${orderNo}/download_materials`,
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `indent-Material-${orderNo}-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);

        link.click();
      }
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async downloadLoadPlan({ commit }, orderNo) {
    try {
      const result = await tmsIndentAxiosInstance({
        url: `order/${orderNo}/download_load_plan`,
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `indent-${orderNo}-load-plan-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);

        link.click();
      }
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async indentTruckChangeAccept({ commit, state }, orderNo) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/accept_truck_change`);
      if (result.data && result.data.id) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
      }
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async acceptFreightChangeRequest({ commit, state }, orderNo) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/freight_change_request/accept`);
      if (result.data && result.data.id) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
      }
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async rejectFreightChangeRequest({ commit, state }, orderNo) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/freight_change_request/reject`);
      if (result.data && result.data.id) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
      }
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async truckChangeAccept({ commit, state }, orderNo) {
    try {
      if (ismock) {
        return mock;
      }
      const result = await tmsIndentAxiosInstance.get(`/order/optimaout?${indendid}`);
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getVehicleUtilization({ commit }, orderNo) {
    try {
      const result = await tmsIndentAxiosInstance(`/order/${orderNo}/vehicle_utilization`);
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async sendForApproval({ commit, state }, { orderNo, data }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/vehicle_utilization_request`, { data });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async sendStatus({ commit, state }, { orderNo, data }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/vehicle_utilization_approval`, { data });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async updateTruck({ commit, state, dispatch }, { orderNo, data }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/vehicle_utilization_update`, { data });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async dowloadAcrossIndentMaterialSample() {
    try {
      const result = await tmsIndentAxiosInstance({
        url: 'order/across_indent_material_upload',
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'across-indent-material-upload.xlsx'); // or any other extension
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async downloadMaterialDeleteSample() {
    try {
      const result = await tmsIndentAxiosInstance({
        url: 'order/download_material_delete_sample',
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'material-delete-upload.xlsx'); // or any other extension
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async downloadMaterialInvoiceGrnSample() {
    try {
      const result = await tmsIndentAxiosInstance({
        url: 'order/download_material_invoice_grn_excel',
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'material-invoice-grn-upload.xlsx'); // or any other extension
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async dowloadAcrossIndentBulkSample() {
    try {
      const result = await tmsIndentAxiosInstance({
        url: 'order/across_indent_upload',
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'indentBulk.xlsx');
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async dowloadAcrossDirectDeliveryIndentBulkSample() {
    try {
      const result = await tmsIndentAxiosInstance({
        url: 'order/across_indent_direct_delivery_upload',
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'directDeliveryIndentBulk.xlsx');
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async dowloadAcrossDirectDispatchIndentBulkSample() {
    try {
      const result = await tmsIndentAxiosInstance({
        url: 'order/across_indent_direct_dispatch_upload',
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'directDispatchIndentBulk.xlsx');
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async dowloadLrBulkSample() {
    try {
      const result = await tmsIndentAxiosInstance({
        url: 'order/lr_sample_format',
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'lrBulkSample.xlsx');
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async checkVehicleCongestion({ commit }, payload) {
    try {
      return await tmsIndentAxiosInstance.post('/order/check_vehicle_congestion', { data: payload });
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async trackingList({ commit }, { id }) {
    try {
      const result = await tmsIndentAxiosInstance.get(`/order/${id}/transporter_bookings_tracking_list`);
      commit('SET_INDENT_TRACKING', result.data || []);
      return result.data || [];
    } catch (error) {
      commit('SET_INDENT_TRACKING', []);
      return HandleResponses.Status(error);
    }
  },
  async getTransporterChangeHistory({ commit }, { id }) {
    try {
      const result = await tmsIndentAxiosInstance.get(`/order/${id}/transporter_history`);
      return result.data || [];
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async retriggerCourierBooking(_, { destinationId, orderNo }) {
    try {
      const result = await tmsIndentAxiosInstance.post(`/order/${orderNo}/destination/${destinationId}/retrigger_courier_booking`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async retryModifiedPicklist({ commit }, { orderId }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderId}/retry_modified_picklist`);
      return result.data || [];
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async saveIndentTrackingNo({ commit }, { id, trackingNo }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${id}/tracking_no`, { data: { trackingNo } });
      return result.data || [];
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async approvalTimeline({ commit }, params) {
    try {
      commit('SET_LOADER_FOR_APPROVAL_DATA', true);
      const result = await axios.get('/event-approval/timeline', { params });
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('SET_LOADER_FOR_APPROVAL_DATA', false);
    }
  },

  async consignmentTrackList({ commit }, { consignment, id }) {
    try {
      commit('SET_CONSIGNMENT_TRACK_LOADING', true);
      const result = await tmsIndentAxiosInstance.post(
        `/order/${id}/fetch_consignment_track_list`,
        {
          data: {
            tracking_id: consignment.tracking_id,
            consignee_id: consignment.consignee_id,
            booking_id: consignment.booking_id,
            source_gate_id: consignment.source_gate_id,
            source_location_id: consignment.source_location_id,
          },
        });
      commit('SET_CONSIGNMENT_TRACKING', (result && result.data
        && result.data.consignment_history) || []);
      return result.data || [];
    } catch (error) {
      commit('SET_CONSIGNMENT_TRACKING', []);
      return HandleResponses.Status(error);
    } finally {
      commit('SET_CONSIGNMENT_TRACK_LOADING', false);
    }
  },
  async approveOTP(_, { orderNo, otp, destinationId }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/destination/${destinationId}/otp/${otp}`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async resendOTP(_, { orderNo, destinationId }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/destination/${destinationId}/resend_otp`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getReturnIndents({ commit }, { masterOrderId, params }) {
    try {
      const result = await tmsIndentAxiosInstance('/order/filter', { params });
      if (result && result.data && result.data[0]) {
        commit('SET_RETURN_INDENTS', { data: result.data[0], masterOrderId });
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async addReturnIndent({ commit }, masterOrderId) {
    try {
      const result = await tmsIndentAxiosInstance.post(`/order/${masterOrderId}/round_trip`);
      if (result && result.data) {
        commit('SET_RETURN_INDENTS', { data: result.data, masterOrderId });
      }
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async get3dVisualization(_, { indentId, revisualize }) {
    try {
      const result = await tmsOptimaAxiosInstance.get(
        `/optima/3d/packing_output?indentId=${indentId}&revisualize=${revisualize}`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async triggerFreightProvision(_, data) {
    try {
      const { orderId } = data;
      const result = await axios.put(`/v2/shipper/order/${orderId}/retry_freight_provision`);
      return result && result.data;
    } catch (error) {
      return false;
    }
  },
  async updateTruckTimestamp(_, { payload, orderNo }) {
    try {
      return await tmsIndentAxiosInstance.put(`/order/${orderNo}/editTruckTimestamp`, { data: payload });
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async updateMaterialComment(_, { orderNo, comment, materialId }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/${materialId}`, { data: comment });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  // Move to Dock for HACH
  async moveToDock({ dispatch }, orderNo) {
    try {
      const response = await tmsIndentAxiosInstance.put(`/order/${orderNo}/moved_to_dock`,
        {});
      await dispatch('find', orderNo);
      return response;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async customFieldsMono(_, { payload, orderNo }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/custom_field_mono`, { data: payload });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  // Move to handOver for HACH
  async handOverComplete({ dispatch }, orderNo) {
    try {
      const response = await tmsIndentAxiosInstance.put(`/order/${orderNo}/handover_completed`,
        {});
      await dispatch('find', orderNo);
      return response;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  // Move back to indented for HACH
  async moveBackToIndented({ dispatch }, orderNo) {
    try {
      const response = await tmsIndentAxiosInstance.put(`/order/${orderNo}/move_back_to_indented`,
        {});
      await dispatch('find', orderNo);
      return response;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  // async getPackingDocumentation(_, params) {
  //   try {
  //     const result = await tmsIndentAxiosInstance.get('packing/document', { params });
  //     return result && result.data;
  //   } catch (error) {
  //     return HandleResponses.Status(error);
  //   }
  // },
  async getPackingDetailsSummary({ commit }, orderNo) {
    try {
      const result = await tmsIndentAxiosInstance.get(`order/${orderNo}/packing_details`);
      if (result && result.data) {
        commit('SET_PACKING_SUMMARY', result.data);
      }
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getCartonDetails({ commit }, { orderNo, jobId, page }) {
    try {
      commit('SET_SUB_DELIVERY_DETAILS_LOADING', true);
      const result = await tmsIndentAxiosInstance.get(`order/${orderNo}/${jobId}/carton_details?page=${page}`);
      if (result && result.data) {
        commit('SET_SUB_DELIVERY_DETAILS', result.data);
      }
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('SET_SUB_DELIVERY_DETAILS_LOADING', false);
    }
  },
  async getAllPackingDocuments(_, params) {
    try {
      const result = await axios.get('packing/document', { params });
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async reTriggerDocuments(_, params) {
    try {
      const result = await axios.post('packing/re_trigger_document', { data: params }, {
        headers: {
          'Content-Type': 'applicatino/json',
        },

      });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async regenerateDocuments(_, params) {
    try {
      const result = await axios.post('packing/re_generate_documents', { data: params }, {
        headers: {
          'Content-Type': 'applicatino/json',
        },

      });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getPackingDocuments({ commit, state }, params) {
    try {
      commit('SET_SUB_DELIVERY_DETAILS_LOADING', true);
      const result = await axios.get('packing/document', { params });
      if (result && result.data) {
        commit('SET_SUB_DELIVERY_DETAILS', result.data);
      }
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('SET_SUB_DELIVERY_DETAILS_LOADING', false);
    }
  },

  async getPackingFreightCharges(_, params) {
    try {
      const result = await axios.get('packing/freight_charges', { params });
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async postPackingFreightCharges(_, params) {
    try {
      const result = await axios.post(`packing/freight_charges?indent_id=${params.indentId}`, { data: params.data });
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async setDeliveryNumberDetails(_, { payload, orderNo }) {
    try {
      const result = await tmsIndentAxiosInstance.post(`order/${orderNo}/delivery_numbers`, { data: payload });
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getDocumentFile(_, { params }) {
    try {
      const result = await axios({
        url: `packing/download_document?url=${params}`,
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const [bucketName, key] = params.split(':::');
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${key}`);
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getPreviewUrl(_, { params, fileExt = 'pdf' }) {
    try {
      const result = await axios({
        url: `packing/download_document?url=${params}`,
        method: 'GET',
        responseType: 'arraybuffer',
      });
      if (result) {
        const fileURL = window.URL.createObjectURL(new Blob([result], { type: `application/${fileExt}` }));
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = fileURL.substr(fileURL.lastIndexOf('/') + 1);
        link.click();
      }
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getPackingURL(_, { id }) {
    try {
      const result = await axios({
        url: `attachment/${id}/read_stream`, // Priya will change
        method: 'GET',
        responseType: 'blob',
      });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async addSignatureAttachment(_, data) {
    try {
      const result = await axios.post('/upload-attachment', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async checkDate(_, { orderId, url, data }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderId}${url}`, { data });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async confirmDate({ commit, dispatch, state }, { orderId, url, data }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderId}${url}`, { data });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async removeAttachments(_, data) {
    try {
      const result = await axios.delete(`/attachment/${data.attachment_id}`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getDepotConfig({ commit }, { depotId, movement = null }) {
    try {
      let result;
      if (movement) {
        result = await tmsIndentAxiosInstance.get(`/bootstrap/depot_config/${depotId}?movement=${movement}`);
      } else {
        result = await tmsIndentAxiosInstance.get(`/bootstrap/depot_config/${depotId}`);
      }
      commit('SET_DEPOT_CONFIGURATION', result.data);
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async addDateRoll(_, data) {
    try {
      const result = await axios.post('packing/dateroll', { data });
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getDateRoll(_, data) {
    try {
      const result = await axios.get('packing/dateroll', { params: data });
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async removeDateRoll(_, data) {
    try {
      const result = await axios.delete('packing/dateroll', { params: data });
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async updateDateRoll(_, data) {
    try {
      const result = await axios.put('packing/dateroll', { data });
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getTrafficValidation(_, data) {
    try {
      const depotId = data.depotId;
      const result = await axios.get(`packing/settings/traffic?depotId=${depotId}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async updateTrafficValidation(_, data) {
    try {
      const result = await axios.post('packing/settings/traffic?depotId', { data });
      return result && result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async globalSearch(_, data) {
    try {
      const search = data.filterKey;
      const result = await axios.get(`packing/search?query=${search}`);
      return result && result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getLastGenerated(_, { carrierId }) {
    try {
      const result = await axios.get('packing/manifest/last_generate', { params: { carrierId } });
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getPackingNotes(_, { delivery_id: deliveryId }) {
    try {
      const result = await axios.get(`packing/notes?delivery_id=${deliveryId}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getVehicleNumberList(_, { data }) {
    try {
      const result = await tmsMdmAxiosInstance.get('vehicle/search_vehicles', { params: data });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async activateAccount(_, { code }) {
    try {
      const result = await axios.put(`packing/dateroll/activate/${code}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async createNotes(_, formData) {
    try {
      const result = await axios.post('packing/notes', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return result && result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getDriverNumberList(_, { data }) {
    try {
      const result = await tmsMdmAxiosInstance.get('driver/search', { params: data });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async removeNotes(_, { id }) {
    try {
      return await axios.put(`packing/notes/remove/${id}`);
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async updateInspectionAttachment({ commit, state, dispatch }, data) {
    try {
      const result = await tmsIndentAxiosInstance.put(
        `/order/${data.orderNo}/inspection_attachment`,
        { data: data.inspectionAttachment });
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async removeInspectionAttachment({ commit, state, dispatch }, data) {
    try {
      const result = await tmsIndentAxiosInstance.delete(
        `/order/${data.orderNo}/inspection_attachment/${data.file_id}`,
      );
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async removeInspectionAttachmentAtDestination({ commit, state, dispatch }, data) {
    try {
      const result = await tmsIndentAxiosInstance.delete(
        `/order/${data.orderNo}/inspection_attachment_at_destination/${data.file_id}`,
      );
      if (result.data) {
        const updatedOrders = Cache.setOrder(state.all, result.data);
        commit('SET_ALL_ORDERS', updatedOrders);
        dispatch('syncEximModule', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async deActivateAccount(_, { code }) {
    try {
      const result = await axios.put(`packing/dateroll/deactivate/${code}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async printAllDocument(_, { orderNumber, documentType, depot }) {
    try {
      const result = await axios.get(`packing/get_document/${documentType}/${orderNumber}?depot=${depot}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async reshipDelivery({ dispatch }, payload) {
    try {
      const reship = (payload && payload.reShipAllDeliveries) || false;
      const body = { data: payload.data };
      const result = await axios.post(`/packing/reship/?reshipAll=${reship}`, body);
      await dispatch('find', (payload && payload.orderNo));
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async fetchFailedDocuments(_, { orderNumber, delivery }) {
    try {
      let query = '';
      if (orderNumber) query += `indent=${orderNumber}&`;
      if (delivery) query += `delivery=${delivery}`;
      const result = await axios.get(`packing/document/failed?${query}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async newFcmNotification({ commit, state }, params) {
    try {
      commit('SET_FCM_DATA', params);
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async newFCMUpdateReceived({ commit, state }, params) {
    try {
      const orders = state.all;
      let { body, title } = params;
      body = JSON.parse(body);
      const { id } = body;
      if (
        title === indentFCMActions.INDENT_STATUS_UPDATE &&
        orders &&
        orders.length
      ) {
        const indent = orders.find(order => order.order_number === id);
        if (indent) {
          const orderId = indent.order_number;
          try {
            commit('SET_ORDER_LOADING', true);
            const result = await tmsIndentAxiosInstance(`/order/${orderId}`);
            commit('SET_ORDER', result.data);
            if (result.data) {
              const updatedOrders = Cache.setOrder(orders, result.data);
              commit('SET_ALL_ORDERS', updatedOrders);
            }
            return result.data;
          } catch (error) {
            return error;
          } finally {
            commit('SET_ORDER_LOADING', false);
          }
        }
      }
    } catch (error) {
      console.log('error', error);
      return HandleResponses.Status(error);
    }
  },

  async fetchPackingAudit(_, { delivery, page }) {
    try {
      let query = '';
      if (delivery) query += `delivery=${delivery}&`;
      if (page) query += `page=${page}`;
      const result = await axios.get(`packing/audit?${query}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async fetchCartonAudit(_, { delivery, page, carton_tag: cartonTag }) {
    try {
      let query = '';
      if (delivery) query += `delivery=${delivery}&`;
      if (cartonTag) query += `carton_tag=${cartonTag}&`;
      if (page) query += `page=${page}`;
      const result = await axios.get(`packing/carton_audit?${query}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getShipMethods(_, { cautionCodes }) {
    try {
      const result = await axios.get(`/packing/shipmethod?caution_codes=${JSON.stringify(cautionCodes)}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getCarrier(_, { payload }) {
    try {
      const result = await axios.get(`/packing/carrier?master_delivery_number=${payload.master_delivery_number}&ship_method_code=${payload.ship_method_code}&country_code=${payload.country_code}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async submitChageShipMethodReship(_, { payload }) {
    try {
      const result = await axios.post('/packing/change_shipmethod_reship', { data: payload });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async packingJobData(_, { payload }) {
    try {
      const result = await axios.get(`/packing/job_data?master_delivery_number=${payload.master_delivery_number}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getIndentStatus(_, { payload }) {
    try {
      const result = await axios.get(`/packing/reship_status/${payload.indent}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async autoPrintDocuments(_, { payload }) {
    try {
      const result = await axios.get(`/document/print_documents/${payload.indent}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getIntegrationTimeLine({ commit }, orderNumber) {
    try {
      commit('SET_ORDER_LOADING', true);
      const result = await tmsIndentAxiosInstance.get(`order/${orderNumber}/integration_timeline`);
      if (result && result.data) {
        commit('SET_INTEGRATION_TIMELINE', result.data);
        return result && result.data;
      }
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async getExceptionData(_, { page = 1, type, category, dateObj, params }) {
    try {
      let query = '';
      query += type ? `&type=${type}` : '';
      query += (category && category.length) ? `&category[]=${category.join('&category[]=')}` : '';
      if (dateObj && dateObj.start_date && dateObj.end_date) {
        query += `&start_date=${dateObj.start_date}&end_date=${dateObj.end_date}`;
      }
      Object.keys(params).forEach((item) => {
        if (params[item]) {
          query += `&${item}=${params[item]}`;
        }
      });

      const result = await tmsIndentAxiosInstance.get(`order/exception_data?page=${page}${query}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getExceptionCounts(_, dateObj) {
    try {
      let query = '';
      if (dateObj && dateObj.start_date && dateObj.end_date) {
        query = `?start_date=${dateObj.start_date}&end_date=${dateObj.end_date}`;
      }
      const result = await tmsIndentAxiosInstance.get(`order/exception_data/meta${query}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getExceptionDetails(_, params) {
    try {
      const { entityNo, entityType } = params;
      const query = `?entity_no=${entityNo}&entity_type=${entityType}`;
      const result = await tmsIndentAxiosInstance.get(`order/exception_data/details${query}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getComments(_, { orderNo, sectionNo }) {
    try {
      const result = await tmsIndentAxiosInstance.get(`order/${orderNo}/comments?section=${sectionNo}`);
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async addComment({ commit }, { orderNo, commentData }) {
    try {
      const result = await tmsIndentAxiosInstance.post(`order/${orderNo}/comments`, { data: { ...commentData } });
      return result.data;
    } catch (err) {
      return HandleResponses.status(err);
    }
  },
  async getCommentattachments({ commit }, { attachable_id }) { // eslint-disable-line
    try {
      // eslint-disable-next-line camelcase
      const result = await tmsIndentAxiosInstance.get(`/commentAttachment/${attachable_id}`);
      return result.data;
    } catch (error) {
      return error;
    }
  },

  async addCommentAttachment(_, { formData }) {
    try {
      const result = await tmsIndentAxiosInstance.post('order/attachment', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getMaterialCategoriesByDepotId(_, { depotId }) {
    try {
      const result = await tmsIndentAxiosInstance.get(`/order/depot_config/material_categories/${depotId}`);
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async manualEndTrip(_, { order }) {
    try {
      const trackTripId = (order.flow.sim_tracking && order.flow.sim_tracking.track_trip_id) ||
        (order.flow.gps_tracking && order.flow.gps_tracking.track_trip_id) || (order.flow.app_tracking && order.flow.app_tracking.track_trip_id);
      const payload = {
        trackTripId, // track trip Id
        reason: 5,
        shipmentNumber: order.order_number,
        clientId: order.client_id,
      };
      const data = await tmsIndentAxiosInstance.post('/order/manual_end_trip', { data: payload });
      return data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getIntegrationCounts(_, dataObj) {
    try {
      let query = '';
      if (dataObj && dataObj.start_date && dataObj.end_date) {
        query = `?start_date=${dataObj.start_date}&end_date=${dataObj.end_date}&event_type=${dataObj.event_type}`;
      }
      if (dataObj.depotIds.length) {
        query += `&depot_id=${dataObj.depotIds}`;
      }
      if (dataObj.transporterIds.length) {
        query += `&transporter_id=${dataObj.transporterIds}`;
      }
      const result = await tmsIndentAxiosInstance.get(`/integration/count${query}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },


  async getCourierIntegrationLogs(_, dataObj) {
    try {
      let query = '';
      if (dataObj && dataObj.start_date && dataObj.end_date) {
        query = `?start_date=${dataObj.start_date}&end_date=${dataObj.end_date}`;
      }
      if (dataObj.type) {
        query += `&type=${dataObj.type}`;
      }
      if (dataObj.courier_type) {
        query += `&coruier_type=${dataObj.courier_type}`;
      }
      const result = await tmsIndentAxiosInstance({ url: `/integration/export${query}`,
        method: 'GET',
        responseType: 'blob',
      });
      if (result.size) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        const fileName = 'courier-logs';
        link.setAttribute('download', `${fileName}-export-${now}.xlsx`);
        document.body.appendChild(link);
        link.click();
      }
      return (result.size === 0) ? 'EXPORT_VIA_EMAIL' : false;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getIntegrationData(_, { page = 1, type, category, dateObj, params }) {
    try {
      let query = '';
      query += type ? `&type=${type}` : '';
      query += (category && category.length) ? `&category[]=${category.join('&category[]=')}` : '';
      if (dateObj && dateObj.start_date && dateObj.end_date) {
        query += `&start_date=${dateObj.start_date}&end_date=${dateObj.end_date}`;
      }
      Object.keys(params).forEach((item) => {
        if (params[item]) {
          query += `&${item}=${params[item]}`;
        }
      });
      const result = await tmsIndentAxiosInstance.get(`/integration/log?page=${page}${query}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getCourierTransporters({ commit }) {
    try {
      const result = await tmsIndentAxiosInstance.get('/integration/transporters');
      commit('SET_COURIER_TRANSPORTER', result.data);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async retryRequest({ commit }, { data }) {
    try {
      const result = await tmsIndentAxiosInstance.post('/integration/retrigger', { data });
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getMitmPayload({ commit }, { tmsTransactionId }) { // eslint-disable-line
    try {
      const result = await tmsIndentAxiosInstance.get(`/integration/${tmsTransactionId}/payload`);
      if (result && result.data) {
        const link = document.createElement('a');
        link.href = result.data;
        link.setAttribute('download', 'MTIM_payload.json');
        document.body.appendChild(link);
        link.click();
      }
      return result.data;
    } catch (error) {
      return error;
    }
  },

  async getPaymentCharges({ commit }, { orderId }) {
    commit('SET_ORDER_LOADING', true);
    try {
      const result = await tmsIndentAxiosInstance.get(`order/${orderId}/payment_charges`);
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('SET_ORDER_LOADING', false);
    }
  },
  async saveMaterialInvoiceLR({ commit }, { orderId, data }) {
    try {
      await tmsIndentAxiosInstance.put(`/order/${orderId}/material_invoice_lorry_receipt`, { data });
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async sendCounterOffer({ commit }, { orderNo, data }) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderNo}/send_counter_offer`, { data });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async triggerManualFreightProvision(_, orderId) {
    try {
      const result = await tmsIndentAxiosInstance.put(`/order/${orderId}/trigger_freight_provision`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async askSi(_, data) {
    try {
      const result = await tmsIndentAxiosInstance.post('/pi/ask-si', { data });
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getMultiLrNumber({ commit }, { params }) {
    try {
      commit('SET_MULTI_LR_LOADING', true);
      const result = await tmsIndentAxiosInstance.get(`/order/multi_lr_view?lr_number=${params}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('SET_MULTI_LR_LOADING', false);
    }
  },
  async downloadMultiLR({ commit }, { params }) {
    try {
      const response = await tmsIndentAxiosInstance({ url: '/order/download_multi_lr',
        method: 'GET',
        params,
        responseType: 'blob' });
      const fileExtentsion = params.lr_number.split(',').length > 1 ? 'zip' : 'pdf';
      const url = window.URL.createObjectURL(new Blob([response]));
      const a = document.createElement('a');
      a.href = url;
      a.download = `E-LR Download.${fileExtentsion}`;
      a.click();
      window.URL.revokeObjectURL(url);
      return null;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getSwimlane(
    { commit },
    {
      swim_lane_name: swimLaneName, depot_id: depotId, page = 1,
      creation_start_date: startDate, creation_end_date: endDate,
      status,
    },
  ) {
    try {
      const result = await tmsIndentAxiosInstance.get('/order/swimlane', {
        params: {
          swim_lane_name: swimLaneName,
          depot_id: depotId,
          page,
          creation_start_date: startDate,
          creation_end_date: endDate,
          status,
        },
      });
      commit('SET_SWIMLANE_DATA', result.data);
      return result.data;
    } catch (error) {
      return error;
    }
  },
};

export default actions;
